import React from "react";
import { graphql } from "gatsby";
import { ArboretumHeadline } from "./ArboretumHeadline";
import {
  KontentComponentSettings,
  KontentRichText,
  StringValue,
} from "../../../types";
import { getMultiChoice } from "../../../lib/multichoice";

interface Props extends KontentComponentSettings {
  title: StringValue;
  simple_rte__text: KontentRichText;
}

const ArboretumHeadlineContainer: React.FC<Props> = ({
  title,
  simple_rte__text,
  component_settings__anchor_name,
  id,
  component_settings__hide_on_mobile,
}) => {
  return (
    <ArboretumHeadline
      title={title.value}
      text={
        simple_rte__text.value !== "<p><br></p>" ? simple_rte__text : undefined
      }
      anchor={component_settings__anchor_name.value}
      id={id}
      hideOnMobile={
        getMultiChoice(component_settings__hide_on_mobile) === "yes"
      }
    ></ArboretumHeadline>
  );
};

export default ArboretumHeadlineContainer;

export const fragmentArboretumHeadlineContainer = graphql`
  fragment ArboretumHeadline on kontent_item_component___arboretum_headline {
    elements {
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      title {
        value
      }
      simple_rte__text {
        ...kontentSimpleRichText
      }
    }
  }
`;
